<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  inject: ['questionnaireContext', 'stepContext'],
  provide() {
    const questionnaireItemContext = {};

    Object.defineProperty(questionnaireItemContext, 'registerQuestion', {
      enumerable: true,
      get: () => this.registerQuestion,
    });

    Object.defineProperty(questionnaireItemContext, 'hasQuestion', {
      enumerable: true,
      get: () => this.hasQuestion,
    });

    Object.defineProperty(questionnaireItemContext, 'index', {
      enumerable: true,
      get: () => this.stepContext.index,
    });

    return {
      questionnaireItemContext,
    };
  },
  data: function () {
    return {
      hasQuestion: [],
    };
  },
  watch: {
    'stepContext.isCurrentStep'(isCurrentStep) {
      if (isCurrentStep) {
        if (!this.hasQuestion.length) return;
        this.questionnaireContext.advanceQuestioning(
          this.hasQuestion[this.hasQuestion.length - 1]
        );
      }
    },
  },
  methods: {
    registerQuestion(index) {
      this.hasQuestion.push(index);
    },
  },
};
</script>
